import { useContext } from "react";
import { AuthContext } from "../../../../Context/AuthContext";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import "./partycard.scss";

import CircleIcon from '@mui/icons-material/Circle';
import PartyCardAction from "../../../../Components/Candidate/PartyCardAction";

export const PartyCard = ({ item, setRefetch }) => { 
  const { t } = useContext(AuthContext);
  return (
    <Box className="party-card">
      <Box className="btn-update">
        <PartyCardAction setRefetch={setRefetch} item={item} />
      </Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2.4}>
          <Avatar
            alt="Remy Sharp"
            src={item?.logo} 
            sx={{ width: 74, height: 74 }}
          />
          <Stack direction="column" spacing={0.6}>
            <Typography className="party-name">{item?.partyName}</Typography>
            <Stack direction="row" alignItems="center" spacing={0.8}>
              <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography className="numbers-ballot" color="gray !important">{t("thead_total_candidate")}</Typography>
                <Typography className="numbers-ballot" color="gray !important">{item?.totalCandidate}{t("thead_people")} {t("thead_female")} {item?.totalCandidateFemale}{t("thead_people")}</Typography>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.8}>
              <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography className="numbers-ballot" color="green !important">{t("thead_full_number")}</Typography>
                <Typography className="numbers-ballot" color="green !important">{item?.totalFullRight}{t("thead_people")} {t("thead_female")} {item?.totalFullRightFemale}{t("thead_people")}</Typography>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.8}>
              <CircleIcon sx={{ fontSize: 6, color: "#37353E !important" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography className="numbers-ballot" color="red !important">{t("thead_total_reserve")} </Typography>
                <Typography className="numbers-ballot" color="red !important">{item?.totalBackup}{t("thead_people")} {t("thead_female")} {item?.totalBackupFemale}{t("thead_people")}</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
          <Typography className="numbers-ballot">{t("thead_numbers_on_the_lottery_ticket")}</Typography>
          <Typography className="numbers">{item?.numbering}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
